import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, Input, forwardRef } from '@angular/core';
import randomId from '../../../../helpers/random-id';
import { IFormInputOption } from '../../../interfaces/form-input-option.interface';
import { ErrorInterface } from '../error/error.interface';
import { LabelInterface } from '../label/label.interface';

@Component({
  selector: 'app-checkbox-btn-input',
  templateUrl: './checkbox-btn-input.component.html',
  styleUrls: ['./checkbox-btn-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxBtnInputComponent),
      multi: true,
    },
  ],
})
export class CheckboxBtnInputComponent implements ControlValueAccessor {
  @Input()
  public className: string;

  @Input()
  public error: ErrorInterface;

  @Input()
  public id: string = randomId();

  @Input()
  public label: LabelInterface;

  @Input()
  public name: string;

  @Input()
  public options: IFormInputOption[] = [];

  private val: { [key: string]: boolean } = {};

  public get value(): { [key: string]: boolean } {
    return this.val || {};
  }

  public set value(val: { [key: string]: boolean }) {
    this.val = val;
    this.onChange(this.val);
  }

  public updateValueItem(key: string, value: boolean) {
    this.value = { ...this.val, [key]: value };
  }

  public writeValue(value: { [key: string]: boolean }) {
    this.val = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  private onChange = (val: { [key: string]: boolean }) => {};
  private onTouched = () => {};
}
